import * as React from "react";
import * as NotificationStore from './notificationsStore'
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { green, amber } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { ApplicationState } from "../store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import { localizations } from "../localization/localization";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = (theme: Theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

function MySnackbarContent(props: any) {
  const { classes, className, message, onClose, onGoTo, variant, goTo, ...other } = props;
  const Icon = variantIcon[variant];

  const remindLaterButton = <Button
    key="remindLater"
    aria-label="Remind Later"
    color="inherit"
    className={classes.close}
    onClick={onClose}
    >
    {localizations.notifications.remindLater}
    <CloseIcon className={classes.icon} />
  </Button>

  const goToButton = <Button
    key="goTo"
    aria-label="Go To"
    color="inherit"
    className={classes.close}
    onClick={onGoTo}
    >
    {localizations.notifications.goTo}
    <ArrowForward className={classes.icon} />
  </Button>

  const closeAndSetUnreadButton = <Button
    key="close"
    aria-label="Close"
    color="inherit"
    className={classes.close}
    onClick={onGoTo}
    >
    {localizations.notifications.close}
    <CloseIcon className={classes.icon} />
  </Button>

  const closeButton = 
  <IconButton
    key="close"
    aria-label="Close"
    color="inherit"
    className={classes.close}
    onClick={goTo !== undefined && goTo.length === 0? onGoTo : onClose}
  >
    <CloseIcon className={classes.icon} />
  </IconButton>

  const actions = (goTo !== undefined ?
    <div>
        { remindLaterButton }
        { goTo.length === 0 ? closeAndSetUnreadButton : goToButton }
    </div>
    : closeButton
  );

  // Add break lines
  const Text = message.split("\n").map((text: string, index: number) => 
    <React.Fragment key={`${text}-${index}`}>
      {text}
      <br />
    </React.Fragment>
  );

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {Text}
        </span>
      }
      action={[actions]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(styles)(MySnackbarContent);

const styles2 = (theme: Theme) => ({
  margin: {
    margin: theme.spacing(1)
  },
});

type NotificationProps = WithStyles<"margin"> & { notificationActions: typeof NotificationStore.actionCreators, goToActions: typeof goActions } & NotificationStore.NotificationState ;

class Notifications extends React.Component<NotificationProps> {

  public handleClose = (id: string) => (event: any, reason: any) => {
    // Do not close if clicked outside of notification 
    if (reason === "clickaway" ) {
      return;
    }
    this.deleteNotification(id);
  };

  public render() {
    const { classes, goToActions } = this.props;
    return (
      <div>
        {this.props.notifications.map((not, index) => (
          <Snackbar
            key={index}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={this.props.notifications.length > 0}
            autoHideDuration={not.autohide ? 6000 : undefined}
            onClose={this.handleClose(not.id)}
          >
            <MySnackbarContentWrapper key={index}
              onClose={this.handleClose(not.id) }
              onGoTo={this.handleGoToClick(goToActions, not.id, not.goTo)}
              variant={not.variant}
              message={not.message}
              goTo={not.goTo}
            />
          </Snackbar>
        ))}
      </div>
    );
  }

  private deleteNotification(id: string){
    if(this.props.notifications.some(n => n.id === id)){
      this.props.notificationActions.deleteNotification(id);
    }
  }

  private handleGoToClick = (goToActions: any, notificationId: string, goTo?: string) => (event: any, reason: any) => {
    if (goTo && goTo.length) {
      goToActions.goTo(goTo);
    }
    this.props.notificationActions.deleteNotification(notificationId);
    this.props.notificationActions.setNotificationRead(notificationId)
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return state.notifications;
}

const goActions = {
  goTo: (location: string) => push(location)
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    notificationActions: bindActionCreators(NotificationStore.actionCreators, dispatch),
    goToActions: bindActionCreators(goActions, dispatch)
  }
}

export default withStyles(styles2)(connect(mapStateToProps, mapDispatchToProps)(Notifications));


// WEBPACK FOOTER //
// ./src/notifications/Notifications.tsx